import { createSelector } from 'reselect';
import get from 'lodash/get';
import { initialState } from './reducer';
import { createSelectFieldOptions } from '../../utils/common';

const selectComposersDomain = state => state.Composers || initialState;

const selectComposersList = () => createSelector(selectComposersDomain, subState => get(subState, 'composers'));
const selectComposersSearchListLoading = () =>
  createSelector(selectComposersDomain, subState => get(subState, 'searchList.loading'));
const selectComposersSearchList = (withAllData = false) =>
  createSelector(selectComposersDomain, subState => {
    const composers = get(subState, 'searchList.data', []);
    const updatedComposer = composers.map(c => {
      const composerdData = { ...c };
      composerdData.fullName = `${get(c, 'firstName')} ${get(c, 'lastName')}`;
      return composerdData;
    });
    return createSelectFieldOptions(updatedComposer, 'id', 'fullName', { slug: 'id' }, withAllData);
  });
export { selectComposersList, selectComposersSearchList, selectComposersSearchListLoading };
